import { slotList } from "@/Util/manifest";

export default {
  Klijent: {
    title: "Klijent",
    plural: "Klijenti",
    labelNew: "Nov klijent",
    hasDeleted: true,
    hasPage: true,
    columns: slotList([
      {
        name: "title",
        label: "Ime klijenta",
        default: true,
        width: "80%",
        searchComponent: "SearchText",
      },
      {
        name: "kraj",
        label: "Kraj ugovora",
        default: true,
        // searchComponent: "SearchText",
        contentComponent: "DispDate",
      },
    ]),
    actions: slotList([
      {
        name: "test",
        label: "Test",
      },
    ]),
    form: slotList([
      {
        cols: 12,
        id: "basic", priority: 0,
        title: "Osnovno",
        groups: slotList([
          {
            id: "main", priority: 0,
            cols: 12,
            fields: slotList([
              {
                id: "title", priority: 0,
                label: "Ime klijenta",
                cols: 12,
              },
              {
                id: "adresa", priority: 0,
                label: "Adresa",
                cols: 6,
              },
              {
                id: "mesto", priority: 0,
                label: "Mesto",
                cols: 3,
              },
              {
                id: "drzava", priority: 0,
                label: "Država",
                cols: 3,
              },
              {
                id: "delatnost", priority: 0,
                label: "Delatnost",
                cols: 6,
              },
              {
                id: "pib", priority: 0,
                label: "PIB",
                cols: 3,
              },
              {
                id: "mb", priority: 0,
                label: "Matični broj",
                cols: 3,
              },
              {
                id: "email", priority: 0,
                label: "Email",
                cols: 6,
              },
              {
                id: "pocetak", priority: 0,
                label: "Početak ugovora",
                cols: 3,
              },
              {
                id: "kraj", priority: 0,
                label: "Kraj ugovora",
                cols: 3,
              },
            ]),
          },
        ]),
      },
    ]),
  },
  Lokacija: {
    title: "Lokacija",
    plural: "Lokacije",
    labelNew: "Nova lokacija",
    hasDeleted: true,
    hasPage: true,
    columns: slotList([
      {
        name: "klijent.title",
        label: "Klijent",
        default: true,
        searchComponent: "SearchText",
      },
      {
        name: "title",
        label: "Lokacija",
        default: true,
        searchComponent: "SearchText",
      },
    ]),
    form: slotList([
      {
        cols: 12,
        id: "basic", priority: 0,
        title: "Osnovno",
        groups: slotList([
          {
            id: "main", priority: 0,
            cols: 12,
            fields: slotList([
              {
                id: "klijent", priority: 0,
                label: "Klijent",
                cols: 3,
              },
              {
                id: "title", priority: 0,
                label: "Lokacija",
                cols: 9,
              },
              {
                id: "brmermesta", priority: 0,
                label: "Br. mernih mesta",
                cols: 3,
              },
            ]),
          }
        ]),
      },
    ]),
  },
  Oprema: {
    title: "Oprema",
    plural: "Oprema",
    labelNew: "Nova oprema",
    hasDeleted: true,
    hasPage: true,
    columns: slotList([
      {
        name: "klijent.title",
        label: "Klijent",
        default: true,
        searchComponent: "SearchText",
      },
      {
        name: "title",
        label: "Naziv",
        default: true,
        searchComponent: "SearchText",
      },
      {
        name: "standard",
        label: "Standard",
        default: true,
        searchComponent: "SearchText",
      }
    ]),
    form: slotList([
      {
        cols: 12,
        id: "basic", priority: 0,
        title: "Osnovno",
        groups: slotList([
          {
            id: "main", priority: 0,
            cols: 12,
            fields: slotList([
              {
                id: "klijent", priority: 0,
                label: "Klijent",
                cols: 3,
              },
              {
                id: "title", priority: 0,
                label: "Naziv",
                cols: 9,
              },
              {
                id: "fabbroj", priority: 0,
                label: "Fabrički broj",
                cols: 4,
              },
              {
                id: "invbroj", priority: 0,
                label: "Inventarski broj",
                cols: 4,
              },
              {
                id: "godina", priority: 0,
                label: "Godina proizvodnje",
                cols: 4,
              },
              {
                id: "intvpregleda", priority: 0,
                label: "Interval Pregleda (meseci)",
                cols: 12,
              },
              {
                id: "napomena", priority: 0,
                label: "Napomena",
                cols: 12,
              },
            ]),
          }
        ]),
      },
    ]),
  },
  ProveraSredine: {
    title: "Provera sredine",
    plural: "Provere sredine",
    labelNew: "Nova provera sredine",
    hasDeleted: true,
    hasPage: true,
    columns: slotList([
      {
        name: "klijent.title",
        label: "Klijent",
        default: true,
        searchComponent: "SearchText",
      },
      {
        name: "lokacija.title",
        label: "Lokacija",
        default: true,
        searchComponent: "SearchText",
      },
      {
        name: "title",
        label: "Vrsta",
        default: true,
        searchComponent: "SearchText",
      },
      {
        name: "datum",
        label: "Datum pregleda",
        default: true,
        contentComponent: "DispDate",
      },
      {
        name: "dateNext",
        label: "Datum isteka",
        contentComponent: "DispDate",
        default: true,
      },
    ]),
    form: slotList([
      {
        cols: 12,
        id: "basic", priority: 0,
        title: "Osnovno",
        groups: slotList([
          {
            id: "main", priority: 0,
            cols: 12,
            fields: slotList([
              {
                id: "klijent", priority: 0,
                label: "Klijent",
                cols: 6,
              },
              {
                id: "lokacija", priority: 0,
                label: "Lokacija",
                cols: 6,
              },
              {
                id: "title", priority: 0,
                label: "Vrsta",
                cols: 12,
                enum: [
                  {value: "Letnja", text: "Letnja"},
                  {value: "Zimska", text: "Zimska"},
                ]
              },
              {
                id: "datum", priority: 0,
                label: "Datum pregleda",
                cols: 4,
              },
              {
                id: "trajanje", priority: 0,
                label: "Trajanje (meseci)",
                cols: 4,
              },
            ]),
          }
        ]),
      },
    ]),
  },
  ElektroPregled: {
    title: "Pregled elektro",
    plural: "Pregledi elektro instalacija",
    labelNew: "Novi pregled",
    hasDeleted: true,
    hasPage: true,
    columns: slotList([
      {
        name: "klijent.title",
        label: "Klijent",
        default: true,
          searchComponent: "SearchText",
      },
      {
        name: "lokacija.title",
        label: "Lokacija",
        default: true,
          searchComponent: "SearchText",
      },
      {
        name: "title",
        label: "Vrsta",
        default: true,
        searchComponent: "SearchText",
      },
      {
        name: "datum",
        label: "Datum pregleda",
        default: true,
        contentComponent: "DispDate",
      },
      {
        name: "dateNext",
        label: "Datum isteka",
        contentComponent: "DispDate",
        default: true,
      },
    ]),
    form: slotList([
      {
        cols: 12,
        id: "basic", priority: 0,
        title: "Osnovno",
        groups: slotList([
          {
            id: "main", priority: 0,
            cols: 12,
            fields: slotList([
              {
                id: "klijent", priority: 0,
                label: "Klijent",
                cols: 6,
              },
              {
                id: "lokacija", priority: 0,
                label: "Lokacija",
                cols: 6,
              },
              {
                id: "title", priority: 0,
                label: "Vrsta",
                cols: 12,
                enum: [
                  {value: "Elektro instalacija", text: "Elektro instalacija"},
                  {value: "Gromobranska instalacija", text: "Gromobranska instalacija"},
                ]

              },
              {
                id: "datum", priority: 0,
                label: "Datum pregleda",
                cols: 4,
              },
              {
                id: "trajanje", priority: 0,
                label: "Trajanje (meseci)",
                             cols: 4,
              },
            ]),
          }
        ]),
      },
    ]),
  },
  OpremaPregled: {
    title: "Pregled opreme",
    plural: "Pregledi opreme",
    labelNew: "Nov pregled opreme",
    hasDeleted: true,
    hasPage: true,
    columns: slotList([
      {
        name: "klijent.title",
        label: "Klijent",
        default: true,
        searchComponent: "SearchText",
      },
      {
        name: "oprema.title",
        label: "Oprema",
        default: true,
        searchComponent: "SearchText",
      },
      {
        name: "datum",
        label: "Datum",
        default: true,
        contentComponent: "DispDate",
      },
      {
        name: "dateNext",
        label: "Datum isteka",
        contentComponent: "DispDate",
        default: true,
      },
    ]),
    form: slotList([
      {
        cols: 12,
        id: "basic", priority: 0,
        title: "Osnovno",
        groups: slotList([
          {
            id: "main", priority: 0,
            cols: 12,
            fields: slotList([
              {
                id: "klijent", priority: 0,
                label: "Klijent",
                cols: 6,
              },
              {
                id: "oprema", priority: 0,
                label: "Oprema",
                cols: 6,
              },
              {
                id: "datum", priority: 0,
                label: "Datum pregleda",
                cols: 4,
              },
              {
                id: "trajanje", priority: 0,
                label: "Trajanje (meseci)",
                cols: 4,
              },
              {
                id: "status", priority: 0,
                label: "Status",
                cols: 4,
              },
              {
                id: "napomena", priority: 0,
                label: "Napomena",
                cols: 12,
              },
            ]),
          }
        ]),
      },
    ]),
  },
  InspektorskiPregled: {
    title: "Inspekcijski nadzor",
    plural: "Inspekcijski nadzori",
    labelNew: "Nov inspekcijski nadzor",
    hasDeleted: true,
    hasPage: true,
    columns: slotList([
      {
        name: "klijent.title",
        label: "Klijent",
        default: true,
          searchComponent: "SearchText",
      },
      {
        name: "lokacija.title",
        label: "Lokacija",
        default: true,
          searchComponent: "SearchText",
      },
      {
        name: "datum",
        label: "Datum pregleda",
        default: true,
          contentComponent: "DispDate",
      },
      {
        name: "dateNext",
        label: "Datum za ispravku",
        contentComponent: "DispDate",
        default: true,
      },
    ]),
    form: slotList([
      {
        cols: 12,
        id: "basic", priority: 0,
        title: "Osnovno",
        groups: slotList([
          {
            id: "main", priority: 0,
            cols: 12,
            fields: slotList([
              {
                id: "klijent", priority: 0,
                label: "Klijent",
                cols: 6,
              },
              {
                id: "lokacija", priority: 0,
                label: "Lokacija",
                cols: 6,
              },
              {
                id: "datum", priority: 0,
                label: "Datum pregleda",
                cols: 4,
              },
              {
                id: "trajanje", priority: 0,
                label: "Rok (dana)",
                cols: 4,
              },
              {
                id: "status", priority: 0,
                label: "Status",
                cols: 4,
              },
              {
                id: "napomena", priority: 0,
                label: "Naložene mere",
                cols: 12,
              },
            ]),
          }
        ]),
      },
    ]),
  },

}
